import React from 'react';
import { withStyles, createStyles, Theme } from '@material-ui/core/styles';
import Switch, { SwitchClassKey, SwitchProps } from '@material-ui/core/Switch';

interface Styles extends Partial<Record<SwitchClassKey, string>> {
  focusVisible?: string;
}

interface Props extends SwitchProps {
  classes: Styles;
}

const generateStyles = (theme: Theme) => createStyles({
  root: {
    width: 42,
    height: 24,
    padding: 0,
  },
  switchBase: {
    padding: 2,
    '&.Mui-disabled': {
      color: '#F6F7F9',
    },
    '&$checked': {
      transform: 'translateX(18px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
      },
      '&.Mui-disabled + $track': {
        opacity: 0.5,
      },
      '&.Mui-disabled': {
        color: '#F6F7F9',
      },
    },
    '&$focusVisible $thumb': {
      color: '#D8D0DA',
    },
  },
  track: {
    borderRadius: 24 / 2,
    backgroundColor: '#BBBFC9',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  disabled: {},
  checked: {},
  thumb: {},
  focusVisible: {},
});

const styledSwitch = withStyles(generateStyles)(({ classes, ...props }: Props) => (
  <Switch
    color="primary"
    focusVisibleClassName={classes.focusVisible}
    classes={{
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked,
    }}
    {...props}
  />
));

export default styledSwitch;
